export default __webpack_public_path__ + "static/media/Income.5866ad48.svg";